import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
const height = 16;
export function Ruler(props) {
  const $ = _c(14);
  const {
    containerWidth: t0,
    viewportWidth: t1
  } = props;
  const containerWidth = t0 === undefined ? 0 : t0;
  const viewportWidth = t1 === undefined ? 0 : t1;
  const t2 = `-${containerWidth / 2} ${-height / 2} ${containerWidth} ${height}`;
  const t3 = -containerWidth / 2;
  let t4;
  if ($[0] !== containerWidth || $[1] !== t3) {
    t4 = <rect x={t3} y={-height / 2} width={containerWidth} height={height} fill="var(--timvir-secondary-background-color)" />;
    $[0] = containerWidth;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = -viewportWidth / 2;
  const t6 = -viewportWidth / 2;
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = <line x1={t5} x2={t6} y1={-height / 2} y2={height / 2} strokeWidth={2} stroke="var(--timvir-text-color)" />;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = viewportWidth / 2;
  const t9 = viewportWidth / 2;
  let t10;
  if ($[6] !== t8 || $[7] !== t9) {
    t10 = <line x1={t8} x2={t9} y1={-height / 2} y2={height / 2} strokeWidth={2} stroke="var(--timvir-text-color)" />;
    $[6] = t8;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== t10 || $[10] !== t2 || $[11] !== t4 || $[12] !== t7) {
    t11 = <svg viewBox={t2} className="xh8yej3 x1lliihq xlup9mm x14kudrl">{t4}{t7}{t10}</svg>;
    $[9] = t10;
    $[10] = t2;
    $[11] = t4;
    $[12] = t7;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
}